module.exports = __webpack_public_path__ + "static/media/bronzing.9fee8242.jpg";